import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { firstValueFrom } from "rxjs";
import { environment } from "@environments/environment";

@Injectable()
export class RequestService {
  jwt: string | undefined;
  url: string = environment.url;
  private http: HttpClient = inject(HttpClient);

  async get(routes: string) {
    return await firstValueFrom(this.http.get(this.url + routes));
  }

  async post(routes: string, data: any) {
    return await firstValueFrom(this.http.post(this.url + routes, data));
  }

  async update(routes: string, data: any) {
    return await firstValueFrom(this.http.put(this.url + routes, data));
  }

  async delete(routes: string, data: any = {}) {
    return await firstValueFrom(this.http.delete(this.url + routes, data));
  }

}
